import getAppBuildAndVersion from '../util/get_app_build_and_version';
import Link                  from '../components/link';
import Navbar                from '../components/navbar';
import React                 from 'react';


export default function LegalPage() {
  return (
    <React.Fragment>
      <Navbar title="Legal"/>
      <div className="page-content">
        <div className="list links-list inset">
          <ul>
            <li>
              <Link external href="https://broadly.com/terms" className="item-content item-link item-inner">
                <div className="item-title">Terms & Conditions</div>
              </Link>
            </li>
            <li>
              <Link external href="https://broadly.com/privacy" className="item-content item-link item-inner">
                <div className="item-title">Privacy Policy</div>
              </Link>
            </li>
          </ul>
          <VersionAndBuild/>
        </div>
      </div>
    </React.Fragment>
  );
}


class VersionAndBuild extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const { build, version } = await getAppBuildAndVersion();
    if (build && version)
      this.setState({ build, version });
  }

  render() {
    const { version, build } = this.state;
    if (version && build) {
      return (
        <div className="block">
          Version {version} build {build}
        </div>
      );
    } else
      return null;
  }
}
